exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scores[data-v-ecc09ff0]{margin-bottom:10px}.finish-block[data-v-ecc09ff0]{margin-bottom:20px}", ""]);

// exports
